module.exports = __webpack_public_path__ + "static/media/arlet@2x.955ea7c5.png";